<template>
  <b-modal
    ref="modalAlterarStatus"
    title="Alterar status da proposta"
    no-close-on-backdrop
    @hidden="resetModal"
    @show="showModal"
  >
    <validation-observer ref="validacao">
      <b-row>
        <b-col cols="12">
          <b-form-group label="Alterar status para:">
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Status"
            >
              <b-form-select
                v-model="form.statusSelecionado"
                :options="opcoes"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >O campo Status é obrigatório</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-form-group label="Informe o motivo:">
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="motivo"
            >
              <b-textarea
                v-model="form.motivo"
                :placeholder="form.statusSelecionado === 'rejeitado' ? 'Insira o motivo da alteração. Esse motivo é interno, não aparecerá no portal do cliente!' : 'Insira o motivo da alteração'"
                rows="3"
                max-rows="3"
              />
              <small
                v-if="errors[0]"
                class="text-danger"
              >O campo motivo é obrigatório</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="form.statusSelecionado === 'aprovada' && propostaAtual.propostasPacotes && propostaAtual.propostasPacotes.length > 1">
        <pacote-status
          :value="form.pacote"
          :pacotes="propostaAtual.propostasPacotes"
          @input="form.pacote = $event"
        />
      </b-row>
      <b-row v-if="form.statusSelecionado === 'rejeitado'">
        <b-col cols="12">
          <b-form-group label="Gerar agenda para próximo contato?">
            <b-form-radio-group
              v-model="form.gerarAgenda"
              :options="[{ text: 'Sim', value: true }, { text: 'Não', value: false }]"
            />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
    <b-row>
      <b-col>
        <file-upload
          ref="uploadandview"
          v-model="arquivo"
          class="btn btn-primary btn-sm"
          style="border-radius: 2px;"
          :multiple="false"
        >
          <i class="fas fa-plus" />
          Carregar anexo
        </file-upload>
        <b-btn
          :disabled="!arquivo || arquivo.length == 0"
          variant="none"
          size="sm"
          class="btn-outline-danger btn-none ml-1"
          @click="remove()"
        >
          <feather-icon icon="TrashIcon" />
        </b-btn>
      </b-col>
    </b-row>
    <span v-if="arquivo && arquivo.length > 0">{{ arquivo[0].name }}</span>
    <template #modal-footer>
      <b-button
        block
        variant="none"
        size="sm"
        class="btn-primary"
        style="margin-left: 0;"
        @click="alterar"
      >Alterar</b-button>
    </template>
    <dados-contratante
      ref="dadosContrante"
      :value="form.dadoContrantante"
      :proposta-id="propostaAtual.id"
      :show-alteracao="false"
      @aprovar="aprovar($event)"
    />
  </b-modal>
</template>

<script>
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import FileUpload from 'vue-upload-component'
import api from '@/app-modulo/comercial/cadastro-proposta/shared/services/api'
import apiEmpresa from '@/app-modulo/comuns/empresa/shared/services/api'
import { getUserData } from '@/auth/utils'

export default {
  name: 'AlterarStatusProposta',
  components: {
    ValidationProvider,
    ValidationObserver,
    FileUpload,
    PacoteStatus: () => import('./shared/components/pacote-status/PacoteStatus.vue'),
    DadosContratante: () => import('../dados-contrantante-interno/DadosContratanteInterno.vue'),
  },
  props: {
    propostaAtual: {
      type: Object,
      default: () => {},
    },
    tipoAcresDesc: {
      type: String,
      default: 'R$',
    },
  },
  data() {
    return {
      messageTitulo: 'Deseja realmente alterar o status dessa proposta?',
      mensagemTexto: 'Essa ação alterará o status da proposta no painel interno e externo.',
      permissaoAlterarPropostaAprovada: getUserData().permissaoAlterarPropostaAprovada,
      form: {
        statusSelecionado: null,
        motivo: null,
        gerarAgenda: true,
        propostaId: 0,
        pacote: null,
        dadoContrantante: {
          tipoInscricaoEmpresa: 'CPF',
          inscricao: null,
          emailsBoletosNFs: [],
          telefoneContato: {
            telefone: null,
            telefoneWhatsApp: false,
            celular: null,
            celularWhatsApp: false,
          },
        },
      },
      opcoes: [
        { value: null, text: '' },
        { value: 'aprovada', text: 'Aprovada' },
        { value: 'naoaprovada', text: 'Não aprovada' },
        { value: 'rejeitado', text: 'Rejeitada' },
      ],
      arquivo: [],
    }
  },
  methods: {
    showModal() {
      const etiquetas = (this.propostaAtual.etiquetas || []).map(e => e.descricao && e.descricao.trim())
      const status = this.propostaAtual.statusProposta
      const opcoes = []

      const temPermissaoAlterar = this.permissaoAlterarPropostaAprovada
      const temEmAlteracao = etiquetas.includes('Em Alteração')
      const temAguardandoEnvio = etiquetas.includes('Aguardando envio de dados')
      const temNaoAprovada = etiquetas.includes('Não aprovada')

      // Helper para adicionar AlterarPropostaAprovadaFinalizada só se tiver permissão
      const addAlterarPropostaAprovadaFinalizada = () => {
        if (temPermissaoAlterar) {
          opcoes.push({ value: 'AlterarPropostaAprovadaFinalizada', text: 'Alterar proposta aprovada/finalizada' })
        }
      }

      if (temAguardandoEnvio) {
        opcoes.push(
          { value: 'emanalise', text: 'Em análise' },
          { value: 'rejeitado', text: 'Rejeitada' },
        )
        addAlterarPropostaAprovadaFinalizada()

        if (temEmAlteracao) {
          opcoes.push({ value: 'aprovada', text: 'Aprovada' })
          // Remove AlterarPropostaAprovadaFinalizada se presente
          const idx = opcoes.findIndex(opt => opt.value === 'AlterarPropostaAprovadaFinalizada')
          if (idx > -1) opcoes.splice(idx, 1)
        }
      } else if (status === 'aprovada' || status === 'aguardandoassinatura') {
        opcoes.push(
          { value: 'rejeitado', text: 'Rejeitada' },
          { value: 'finalizada', text: 'Finalizada' },
        )

        addAlterarPropostaAprovadaFinalizada()

        if (status === 'aguardandoassinatura') {
          opcoes.push({ value: 'naoaprovada', text: 'Não aprovada' })
        }

        if (temEmAlteracao) {
          opcoes.push({ value: 'aprovada', text: 'Aprovada' })
          const idx = opcoes.findIndex(opt => opt.value === 'AlterarPropostaAprovadaFinalizada')
          if (idx > -1) opcoes.splice(idx, 1)
        }
      } else if (['finalizada', 'pendenteenvio', 'checklist'].includes(status)) {
        opcoes.push(
          { value: 'rejeitado', text: 'Rejeitada' },
        )
        addAlterarPropostaAprovadaFinalizada()

        if (temEmAlteracao) {
          opcoes.push({ value: 'finalizada', text: 'Finalizada' })
          const idx = opcoes.findIndex(opt => opt.value === 'AlterarPropostaAprovadaFinalizada')
          if (idx > -1) opcoes.splice(idx, 1)
        }
      }

      // Remove 'naoaprovada' se já estiver como etiqueta
      if (temNaoAprovada && opcoes.some(opt => opt.value === 'naoaprovada')) {
        const idx = opcoes.findIndex(opt => opt.value === 'naoaprovada')
        if (idx > -1) opcoes.splice(idx, 1)
      }

      if (status === 'negociacao') {
        opcoes.push(
          { value: 'aprovada', text: 'Aprovada' },
          { value: 'naoaprovada', text: 'Não aprovada' },
          { value: 'rejeitado', text: 'Rejeitada' },
        )
      }

      if (status === 'naoaprovada') {
        opcoes.push(
          { value: 'aprovada', text: 'Aprovada' },
          { value: 'rejeitado', text: 'Rejeitada' },
        )
      }

      this.opcoes = opcoes
    },
    alterar() {
      if (this.form.statusSelecionado === 'emanalise') {
        this.messageTitulo = 'Atenção!'
        this.mensagemTexto = 'Ao realizar a alteração de status manual, será alterado o status da proposta de "Aguardando envio de dados" para "Em análise" e a responsabilidade pelo preenchimento dos dados para geração do contrato será da contabilidade, não sendo possível reverter a ação! Deseja continuar?'
      }
      this.$refs.validacao.validate()
        .then(success => {
          if (success) {
            if (this.form.statusSelecionado && this.form.motivo && this.form.motivo !== '') {
              this.$confirmar(this.messageTitulo, this.mensagemTexto, 'question', 'danger')
                .then(result => {
                  if (result.value) {
                    if (this.propostaAtual.semContratante && this.form.statusSelecionado === 'aprovada') {
                      this.$refs.dadosContrante.show()
                    } else {
                      this.aprovar()
                    }
                  }
                })
            } else {
              this.$erro(!this.form.motivo || this.form.motivo === '' ? 'O campo de motivo é obrigatório!' : 'Preencha todos os campos!')
            }
          } else {
            this.$erro('Preencha todos os campos!')
          }
        })
    },
    // NOVO MÉTODO: usado quando o botão "clique aqui" deve alterar direto para "Em análise"
    alterarDiretoEmAnalise() {
      const userData = getUserData && getUserData()
      const nomeUsuario = userData && (userData.nome || userData.name || userData.username)
      const motivoBase = 'Usuário decidiu inserir os dados pelo Honorarium'
      const motivo = nomeUsuario ? `${motivoBase} (${nomeUsuario})` : motivoBase

      // Preenche o form com os dados necessários para o fluxo atual
      this.form.statusSelecionado = 'emanalise'
      this.form.motivo = motivo
      this.form.gerarAgenda = true
      this.form.propostaId = this.propostaAtual.id

      // Chama diretamente o fluxo de aprovação/alteração de status
      this.aprovar()
    },
    aprovar(contrantante = null) {
      if (contrantante) {
        this.form.dadoContrantante = contrantante
      }
      this.removerPorcentagem(this.form.pacote)
      const formData = { ...this.form }
      formData.propostaId = this.propostaAtual.id
      const formBody = this.getFormDataBody(formData)
      api.alterarStatusProposta(formBody)
        .then(payload => {
          this.$emit('alterar-status', payload.data)
          this.$sucesso('Alterado status da proposta')
          this.$refs.modalAlterarStatus.hide()
          if (this.form.statusSelecionado === 'aprovada' && this.propostaAtual.tipoProposta !== 'semchecklist' && !this.propostaAtual.geraContrato) {
            apiEmpresa.cadastroEmpresaProposta(this.propostaAtual.id)
          }
        })
        .catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: err.response.statusText !== '' ? err.response.statusText : (err.response.data.message || err.message),
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          throw err
        })
    },
    resetModal() {
      this.form = {
        statusSelecionado: null,
        motivo: null,
        gerarAgenda: true,
      }
      this.arquivo = []
    },
    remove() {
      this.$refs.uploadandview.remove(this.arquivo[0])
    },
    getFormDataBody(body) {
      const formData = new window.FormData()
      const file = this.arquivo[0]
      if (file) {
        formData.append('file', file.file, file.filename || file.name)
      }
      formData.append('body', JSON.stringify(body))

      return formData
    },
    getValorTotalPacote(option) {
      let valor = option.valorPacote
      if (this.tipoAcresDesc === '%') {
        if (typeof option.acrescimoPacote === 'string') {
          valor += ((parseFloat(option.acrescimoPacote.replace('%', ''), 10) / 100) * valor)
        }
        if (typeof option.descontoPacote === 'string') {
          valor -= ((parseFloat(option.descontoPacote.replace('%', ''), 10) / 100) * valor)
        }
      } else {
        valor += option.acrescimoPacote || 0
        valor -= option.descontoPacote || 0
      }
      return valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    },
    removerPorcentagem(value) {
      if (this.tipoAcresDesc === '%' && value) {
        if (value.acrescimoPacote) {
          this.form.pacote.acrescimoPacote = parseFloat(value.acrescimoPacote.replace('%', ''), 10)
        }
        if (value.descontoPacote) {
          this.form.pacote.descontoPacote = parseFloat(value.descontoPacote.replace('%', ''), 10)
        }
      }
    },
  },
}
</script>
